import { FC, Component as ReactComponent, ComponentClass } from 'react'
import { remote } from 'helpers/mobileAppHelpers'
import { hoistNonReactStatics } from 'tangle-shared'

const withReadyEvent = function <TProps> (
  Component: ComponentClass<TProps> | FC<TProps>,
) {
  class ComponentWithReadyEvent extends ReactComponent<TProps> {
    static displayName = `withReadyEvent(${ Component.displayName || Component.name })`

    private animationFrame: number

    render () {
      return (
        <Component { ...this.props } />
      )
    }

    componentDidMount () {
      this.animationFrame = requestAnimationFrame(remote.sendReadyEvent)
    }

    componentWillUnmount () {
      cancelAnimationFrame(this.animationFrame)
    }
  }

  return hoistNonReactStatics(ComponentWithReadyEvent, Component)
}

export default withReadyEvent
